// Aritmetika warna kecil untuk tema merek (AppContext). Hanya menerima #RRGGBB.

export const HEX = /^#[0-9a-f]{6}$/i

export const toRgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16))

export const toHex = (a) =>
  '#' + a.map((v) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join('')

export const mixWhite = (h, t) => toHex(toRgb(h).map((v) => v + (255 - v) * t))

export const darken = (h, t) => toHex(toRgb(h).map((v) => v * (1 - t)))

// Luminansi relatif WCAG 2.x.
const luminance = (h) => {
  const [r, g, b] = toRgb(h).map((v) => {
    const c = v / 255
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4
  })
  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}

export const contrast = (a, b) => {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x)
  return (hi + 0.05) / (lo + 0.05)
}

// Warna merek yang gelap (ungu tua, biru laut) nyaris hilang di permukaan gelap.
// Dinaikkan terangnya sedikit demi sedikit sampai kontrasnya terhadap permukaan
// mencapai `min` (3:1, batas WCAG untuk ikon dan garis). Warna yang sudah cukup
// terang tidak disentuh, jadi terakota bawaan tetap persis terakota.
export function liftForDark(hex, surface, min = 3) {
  if (contrast(hex, surface) >= min) return hex
  for (let t = 0.05; t <= 1; t += 0.05) {
    const c = mixWhite(hex, t)
    if (contrast(c, surface) >= min) return c
  }
  return '#ffffff'
}

// Warna teks di atas warna merek (tombol utama). Putih adalah rancangan dasar,
// jadi dipertahankan selama masih terbaca; hanya warna yang benar-benar terang
// (kuning, limau, pastel) yang berpindah ke teks gelap.
//
// Ambangnya 3:1 — batas WCAG untuk teks besar dan komponen antarmuka — bukan
// 4.5:1. Dengan 4.5 hampir semua warna merek menengah (teal, oranye, hijau)
// berpindah ke teks gelap, dan itu mengubah tombol lembaga yang selama ini
// putih tanpa ada yang mengeluh. Yang diselamatkan di sini adalah kasus
// yang memang tak terbaca: putih di atas kuning ≈ 1.3:1.
export const INK_ON_LIGHT = '#14181a'
export function onColor(hex, min = 3) {
  if (!HEX.test(hex || '')) return '#ffffff'
  if (contrast('#ffffff', hex) >= min) return '#ffffff'
  return contrast(INK_ON_LIGHT, hex) > contrast('#ffffff', hex) ? INK_ON_LIGHT : '#ffffff'
}
